import isUndefined from 'onyx-common/isUndefined'

const isDefined = val => !isUndefined(val)

export default isDefined
